
    const data = {"name":"src/core/icons/database","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M12 3C7.58 3 4 4.79 4 7s3.58 4 8 4 8-1.79 8-4-3.58-4-8-4M4 9v3c0 2.21 3.58 4 8 4s8-1.79 8-4V9c0 2.21-3.58 4-8 4s-8-1.79-8-4m0 5v3c0 2.21 3.58 4 8 4s8-1.79 8-4v-3c0 2.21-3.58 4-8 4s-8-1.79-8-4Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            